import { Notification, PlanSubscription, Users, Clients } from "./context";
import "./App.css";
import "./assets/css/treffas.css";
import "./assets/css/coach-website-fonts.css";
import "./assets/css/main.css";
import Auth from "./auth";
import React, { useState } from "react";
import { CssBaseline, Grow, ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import Routes from "./routes";
import { SnackbarProvider } from "notistack";
import { ToastContainer, Zoom } from "react-toastify";
import "src/assets/css/new-static-calendar.css"; // custom css for full calendar
import "src/assets/css/custom-quill.css"; // custom css for full calendar

import mixpanel from "mixpanel-browser";
import { MixpanelProvider } from "react-mixpanel";
import { SnackbarContextProvider } from "./context/SnackbarContext";
import { IntegrationsContextProvider } from "./context/IntegrationsContext";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

/** import all the integration resource */
import MailchimpResource from "src/views/coach/integrations/v2/mailchimp/Resource";
import AweberResource from "src/views/coach/integrations/v2/aweber/Resource";
import ActiveCampaignResource from "src/views/coach/integrations/v2/active-campaign/Resource";
import ConvertkitResource from "src/views/coach/integrations/v2/convertkit/Resource";
import GetresponseResource from "src/views/coach/integrations/v2/getresponse/Resource";
import MailerLiteResource from "src/views/coach/integrations/v2/mailerlite/Resource";
import PandadocResource from "src/views/coach/integrations/v2/pandadoc/Resource";
import DocusignResource from "src/views/coach/integrations/v2/docusign/Resource";

import { Main } from "./Main";
import ClientAuth from "./auth/client";
import ClientPortalRoutes from "./routes/client-portal";

function App() {
  const [user, setUser] = useState(null);
  const [planSubscription, setPlanSubscription] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [isLogin, setIsLogin] = useState(false);
  const [userIntegrations, setUserIntegrationList] = useState([]);
  const notistackRef = React.createRef();
  const list = new Main();
  const __loginType = localStorage.getItem("__loginType") ?? "coach";

  const [client, setClient] = useState(null);

  // register integration resources in app
  list.register({
    mailchimp: MailchimpResource,
    aweber: AweberResource,
    active_campaign: ActiveCampaignResource,
    convertkit: ConvertkitResource,
    getresponse: GetresponseResource,
    mailerlite: MailerLiteResource,
    pandadoc: PandadocResource,
    docusign: DocusignResource,
  });

  React.useEffect(() => {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY);

    // generateIntegrations();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        // autoHideDuration={1200}
        maxSnack={1}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        TransitionComponent={Grow}
        ref={notistackRef}
        iconVariant={{
          success: <CheckCircleOutlineIcon sx={{ marginRight: "12px" }} />,
          error: <HighlightOffIcon sx={{ marginRight: "12px" }} />,
        }}
        classes={{
          variantSuccess: "custom-snackbar-success",
        }}
      >
        <SnackbarContextProvider>
          <MixpanelProvider mixpanel={mixpanel}>
            {__loginType === "client" ? (
              /* __loginType is client */
              <Clients.Provider
                value={{
                  client: client,
                  updateClient: setClient,
                  isLogin: isLogin,
                  setIsLogin: (status) => setIsLogin(status),
                  mixpanel: mixpanel,
                }}
              >
                <ClientAuth>
                  <Notification.Provider
                    value={{
                      notifications: notifications,
                      setNotifications: setNotifications,
                    }}
                  >
                    <ClientPortalRoutes />
                  </Notification.Provider>
                </ClientAuth>
              </Clients.Provider>
            ) : (
              // / __loginType is default coach/user
              <Users.Provider
                value={{
                  user: user,
                  updateUser: setUser,
                  isLogin: isLogin,
                  setIsLogin: (status) => setIsLogin(status),
                  mixpanel: mixpanel,
                  setUserIntegrationList,
                  userIntegrations,
                }}
              >
                <PlanSubscription.Provider
                  value={{
                    planSubscription: planSubscription,
                    setPlanSubscription: setPlanSubscription,
                  }}
                >
                  <Auth>
                    <Notification.Provider
                      value={{
                        notifications: notifications,
                        setNotifications: setNotifications,
                      }}
                    >
                      <IntegrationsContextProvider integrationResource={list}>
                        <Routes />
                      </IntegrationsContextProvider>
                    </Notification.Provider>
                  </Auth>
                </PlanSubscription.Provider>
              </Users.Provider>
            )}
          </MixpanelProvider>
        </SnackbarContextProvider>
      </SnackbarProvider>

      {/* toaster */}
      <ToastContainer
        position="top-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName={"snackbar-customize"}
        transition={Zoom}
      />
    </ThemeProvider>
  );
}

export default App;
